












































































































































































































import { LicenseUtil } from '@/api/license'
import SpinnerPopup from '@/components/shared/SpinnerPopup'
import NavButton from '@/components/shared/NavButton'
import { Pages } from '@/pages'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { permissions } from '@/userUtils'
import { ISnackbar } from '@/model'

@Component({
  methods: { permissions },
  components: {
    SpinnerPopup: SpinnerPopup,
    NavButton: NavButton
  },
  computed: {
    ...mapGetters('user', [ 'userPermissions' ])
  }
})
export default class License extends Vue {
  @Prop({ default: '' }) private routeBack!: string

  private homeRouteLink: any = Pages.HOME.routeLink
  private showInput: boolean = false
  private spinner: boolean = false
  private app: string = 'coboware'
  private username: string = ''
  private password: string = ''
  private licenseKey: string = ''
  private licenseKeyInput: string = ''
  private licenseExp: string = ''
  private isTrialLicense: boolean = false
  private trialRenewals: number = 0
  private trialMaxRenewals: number = 0
  private readonly defaultTrialMaxRenewals: number = 2
  private isLocalLicense: boolean = false
  private remoteLicenseNotFound: boolean = false
  private radioGroup: string = '0'
  private hardwareKey: string = ''
  private ready: boolean = false
  private userActionThatRequiresLicense: string = ''
  private userPermissions!: string[]
  private snackBar: ISnackbar = {show: false, text: '', color: '', timeout: 10000}

  private rules: {required: any, min: any, ascii: any} = {
    required: (v: any) => !!v || this.localText('license.nameReq'),
    min: (v: any) => (v && v.length >= 8) || this.localText('license.nameLen'),
    ascii: (v: any) => {
      const pattern = /^[\x20-\x7F]+$/ // ascii
      return pattern.test(v) || this.localText('general.invalidChars')
    }
  }

  get state () {
    if (this.remoteLicenseNotFound) {
      return {
        val: 'NOT_FOUND',
        color: 'error',
        message1: `${this.$t('license.notFound')}`,
        message2: `${this.$t('license.check')}`
      }
    }
    if (this.isLocalLicense) {
      if (this.isTrialLicense) {
        return {
          val: 'LOCAL',
          color: 'success',
          message1: 'Trial license active',
          message2: `${this.$t('license.expires')}: ${this.licenseExp}`,
          message3: this.trialRenewalMessage
        }
      }
      return {
        val: 'LOCAL',
        color: 'success',
        message1: `${this.$t('license.yourKey')}: ${this.licenseKey}`,
        message2: `${this.$t('license.expires')}: ${this.licenseExp}`
      }
    }
    if (this.licenseKey && this.licenseKey.length > 0) {
      return {
        val: 'NEW',
        color: 'primary',
        message1: `${this.$t('license.yourKey')}: ${this.licenseKey}`,
        message2: `${this.$t('license.expires')}: ${this.licenseExp}`
      }
    }
    return {
      val: 'UNDEFINED',
      color: 'warn'
    }
  }

  get canStartTrial () {
    return !this.licenseKey
  }

  get trialRenewalMessage () {
    const message = `Trial renewals: ${this.trialRenewals} / ${this.trialMaxRenewals}`
    if (this.trialMaxRenewals > 0 && this.trialRenewals >= this.trialMaxRenewals) {
      return `${message}. No trial renewals remaining.`
    }
    return message
  }

  mounted () {
    this.userActionThatRequiresLicense = this.$route.params.userActionThatRequiresLicense
    this.getHardwareKey()
    this.tryLocalLicense()
  }

  private async signIn () {
    this.spinner = true
    this.remoteLicenseNotFound = false
    const lic = await LicenseUtil.get(this.app, this.username, this.password)
    this.spinner = false
    if (!this.apply(lic)) {
      console.log('[DEBUG] License not found at License Admin Server')
      return
    }
    this.back()
  }

  private async startTrial () {
    if (!this.canStartTrial) {
      return
    }
    this.spinner = true
    this.remoteLicenseNotFound = false
    const lic = await LicenseUtil.startTrial(this.app)
    this.spinner = false
    if (!this.apply(lic)) {
      this.snackBar.show = false
      this.$nextTick(() => {
        this.snackBar.show = true
        this.snackBar.color = 'warning'
        this.snackBar.text = 'Trial license is no longer available'
        this.snackBar.timeout = 10000
      })
      return
    }
    this.back()
  }

  private async getHardwareKey () {
    this.hardwareKey = await LicenseUtil.getHardwareKey(this.app)
  }

  private async tryLocalLicense () {
    this.spinner = true
    const lic = await LicenseUtil.tryLocal(this.app)
    this.spinner = false
    if (!lic) {
      this.licenseKey = ''
      this.ready = true
      return
    }
    const result = this.apply(lic)
    if (result) {
      this.back()
    }
    this.ready = true
  }

  private updateToolbarButtonClick () {
    this.isLocalLicense = false
  }

  private keyHandler (event: any) {
    if (event.code === 'Enter') {
      this.signIn()
    }
  }

  private apply (lic: any): boolean {
    if (!lic || !lic.licenseKey || lic.licenseKey === '') {
      this.licenseKey = ''
      this.isTrialLicense = false
      this.trialRenewals = 0
      this.trialMaxRenewals = 0
      this.remoteLicenseNotFound = true
      return false
    }
    this.remoteLicenseNotFound = false
    this.licenseKey = lic.licenseKey
    this.isTrialLicense = lic.trial === true
    this.trialMaxRenewals = this.isTrialLicense ? lic.trialMaxRenewals || this.defaultTrialMaxRenewals : 0
    this.trialRenewals = this.isTrialLicense ? Math.min(lic.trialRenewals || 0, this.trialMaxRenewals) : 0
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    this.licenseExp = (new Date(lic.validTo)).toLocaleDateString(navigator.language, options)
    this.$store.commit('environment/LICENSE_UPDATED', lic)
    this.isLocalLicense = true
    return true
  }

  private back() {
    // route back if a route was provided
    if (this.userActionThatRequiresLicense != null && this.userActionThatRequiresLicense === this.localText ('listButtons.newPal')) {
      this.routeBack = '/create-pallet-pattern'
      // console.log ('License.back - new route: ', JSON.stringify (this.routeBack))
    }
    if (this.routeBack !== '') {
      // setTimeout(() => {
      this.$router.push ({path: this.routeBack})
      // }, 1000)
    }
  }

  private async acceptInputKey () {
    this.spinner = true
    try {
      const key = LicenseUtil.group(this.licenseKeyInput, 5)
      console.log('[DEBUG] key:', key)
      const result = await LicenseUtil.verifyKey(key, this.app)
      if (result) {
        const lic = await LicenseUtil.tryLocal(this.app)
        const value = this.apply(lic)
        if (value) {
          this.back()
        }
      }
    } catch (e) {
      console.log('[ERROR] License.acceptInputKey()', e)
    }
    this.spinner = false
  }

  private localText (b: string): string {
    return String(this.$t(b))
  }

  private userCannotModifyLicense() {
    return !this.userPermissions.includes(permissions.MODIFYLICENSE)
  }

  private showPermissionDeniedWarning() {
    this.snackBar.show = false
    this.$nextTick(() => {
      if (this.userCannotModifyLicense()) {
        this.snackBar.show = true
        this.snackBar.color = 'warning'
        this.snackBar.text = String(this.$t('settings.permissionDenied'))
        this.snackBar.timeout = 10000
      }
    })
  }
}

